<template>
  <div class="est-room__controls">
    <button type="button"
            class="est-room__ctrl"
            :class="{ 'is-off': !cameraOn }"
            :disabled="disabled"
            :aria-pressed="String(!cameraOn)"
            :aria-label="cameraOn ? $t('OnlineMeetingComponent.TurnOffCamera') : $t('OnlineMeetingComponent.TurnOnCamera')"
            :title="cameraOn ? $t('OnlineMeetingComponent.TurnOffCamera') : $t('OnlineMeetingComponent.TurnOnCamera')"
            @click="$emit('toggle-camera')">
      <span class="est-room__ctrl-icon"><font-awesome-icon :icon="cameraOn ? 'fa-solid fa-video' : 'fa-solid fa-video-slash'" /></span>
      <span class="est-room__ctrl-label">{{ $t('OnlineMeetingComponent.DeviceCamera') }}</span>
    </button>

    <button type="button"
            class="est-room__ctrl"
            :class="{ 'is-off': !micOn }"
            :disabled="disabled"
            :aria-pressed="String(!micOn)"
            :aria-label="micOn ? $t('OnlineMeetingComponent.TurnOffMicrophone') : $t('OnlineMeetingComponent.TurnOnMicrophone')"
            :title="micOn ? $t('OnlineMeetingComponent.TurnOffMicrophone') : $t('OnlineMeetingComponent.TurnOnMicrophone')"
            @click="$emit('toggle-mic')">
      <span class="est-room__ctrl-icon"><font-awesome-icon :icon="micOn ? 'fa-solid fa-microphone' : 'fa-solid fa-microphone-slash'" /></span>
      <span class="est-room__ctrl-label">{{ $t('OnlineMeetingComponent.DeviceMicrophone') }}</span>
    </button>

    <!-- Sahne düzeni: varsayılan karşı taraf büyük + köşede kendi görüntün;
         düğme sahneyi ortadan ikiye bölen karo düzenine geçirir (karolar alt
         alta). Kartta da tam ekranda da vardır. -->
    <button v-if="showLayout"
            type="button"
            class="est-room__ctrl"
            :class="{ 'is-active': isSplit }"
            :aria-pressed="String(isSplit)"
            :aria-label="$t('OnlineMeetingComponent.LayoutToggle')"
            :title="$t('OnlineMeetingComponent.LayoutToggle')"
            @click="$emit('toggle-layout')">
      <span class="est-room__ctrl-icon"><font-awesome-icon icon="fa-solid fa-table-columns" /></span>
      <span class="est-room__ctrl-label">{{ $t('OnlineMeetingComponent.LayoutToggle') }}</span>
    </button>

    <button v-if="showFullscreen"
            type="button"
            class="est-room__ctrl"
            :aria-pressed="String(isFullscreen)"
            :aria-label="isFullscreen ? $t('OnlineMeetingComponent.ExitFullscreen') : $t('OnlineMeetingComponent.EnterFullscreen')"
            :title="isFullscreen ? $t('OnlineMeetingComponent.ExitFullscreen') : $t('OnlineMeetingComponent.EnterFullscreen')"
            @click="$emit('toggle-fullscreen')">
      <span class="est-room__ctrl-icon"><font-awesome-icon :icon="isFullscreen ? 'fa-solid fa-compress' : 'fa-solid fa-expand'" /></span>
      <span class="est-room__ctrl-label">{{ $t('OnlineMeetingComponent.EnterFullscreen') }}</span>
    </button>

    <button v-if="showEnd"
            type="button"
            class="est-room__ctrl est-room__ctrl--end"
            :disabled="isEnding"
            :aria-label="$t('OnlineMeetingComponent.EndMeeting')"
            :title="$t('OnlineMeetingComponent.EndMeeting')"
            @click="$emit('end-meeting')">
      <span class="est-room__ctrl-icon"><font-awesome-icon :icon="isEnding ? 'fa-solid fa-circle-notch' : 'fa-solid fa-phone-slash'" :spin="isEnding" /></span>
      <span class="est-room__ctrl-label">{{ $t('OnlineMeetingComponent.EndShort') }}</span>
    </button>
  </div>
</template>

<script>
  // Kontrol şeridi hem hazırlık hem görüşme hâlinde basılıyor; markup'ı iki
  // bileşende kopyalamak yerine tek yerde durur (davranış çağıranda kalır).
  //
  // Şerit sahnenin İÇİNDE durur: tam ekranda da görünür kalması için (Fullscreen
  // API yalnız istenen elemanı ve altını gösterir).
  export default {
    name: 'MeetingControlsComponent',
    props: {
      cameraOn: Boolean,
      micOn: Boolean,
      // Akış yokken buton tıklanabilir kalırsa `getVideoTracks()[0]` patlıyordu.
      disabled: Boolean,
      // Tam ekran, düzen ve bitirme yalnız görüşme sahnesinde anlamlı; hazırlık
      // ekranında basılmazlar.
      showFullscreen: Boolean,
      isFullscreen: Boolean,
      showLayout: Boolean,
      isSplit: Boolean,
      showEnd: Boolean,
      isEnding: Boolean
    }
  }
</script>
